import React from "react";
import "./App.css";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Hotels from "./pages/Hotels";
import PlanTrip from "./pages/PlanTrip";
import ThingsToDo from "./pages/ThingsToDo";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminArticles from "./pages/AdminArticles";
import BlogList from "./pages/BlogList";
import ArticlePage from "./pages/ArticlePage";
import ProtectedRoute from "./components/ProtectedRoute";
import { usePageViews } from "./lib/analytics";

const PageViewTracker = () => {
  usePageViews();
  return null;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PageViewTracker />
          <Toaster
            position="top-center"
            richColors
            toastOptions={{
              style: { fontFamily: "Manrope, sans-serif" },
            }}
          />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/hotels" element={<Hotels />} />
              <Route path="/plan-your-trip" element={<PlanTrip />} />
              <Route path="/things-to-do" element={<ThingsToDo />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<ArticlePage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/articles"
              element={
                <ProtectedRoute>
                  <AdminArticles />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
